import { matchesUrl } from "@findemdev/findem-helpers";
import { getIntegrationsUrl } from "../utils/common";

export interface IAdminIframeRouteConfig {
  path: string;
  iframeRoute: string;
}

export const ADMIN_IFRAME_ROUTES: IAdminIframeRouteConfig[] = [
  {
    path: "/manage_users",
    iframeRoute: `${matchesUrl}/hm/cols_slonly`,
  },
  {
    path: "/integrations",
    iframeRoute: getIntegrationsUrl() || '',
  },
];

